import React, { useMemo } from 'react';
import { Box, FormControl, FormLabel, Grid, Link, Tooltip } from '@mui/material';
import { Warning } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import FolioRadioGroup from '@/components/FolioRadioGroup';
import {
	ADDRESS,
	CITY,
	CLIENT_ID,
	CLIENT_NAME,
	COUNTRY,
	DATE_OF_BIRTH,
	EMAIL,
	FIRST_NAME,
	INDUSTRY,
	IS_EXISTING,
	IS_PROSPECT,
	LAST_NAME,
	PHONE,
	PHONE2,
	POSTCODE,
	SUBURB,
	WEBSITE,
} from '../validationSchema';

export const ExistingClientToggle = ({ disabled }) => {
	const { values, initialValues, setFieldValue } = useFormikContext();
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);
	const external = userDetails?.external;

	const canCreate = useMemo(
		() =>
			external
				? userDetails?.salesTeamId != null
				: userDetails?.salesTeamId != null && userDetails?.authorisedRepId != null,
		[userDetails],
	);

	return (
		<Grid size={values[IS_EXISTING] ? 12 : 8}>
			<FormLabel>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<span
						style={{
							paddingRight: '0.5em',
						}}
					>
						{'New or existing client'}
					</span>
					{!canCreate && (
						<Tooltip
							title={
								<>
									<span>
										{
											'It looks like you do not have permission to create clients. Please contact '
										}
									</span>
									<Link
										href='mailto:support@folio.insure'
										target='_blank'
										rel='noopener'
										color='inherit'
									>
										{'support@folio.insure'}
									</Link>
									<span>{' for assistance.'}</span>
								</>
							}
							placement='right'
						>
							<Warning
								color='warning'
								sx={{
									fontSize: '1.2em',
								}}
							/>
						</Tooltip>
					)}
				</Box>
			</FormLabel>
			<FormControl fullWidth>
				<FolioRadioGroup
					name={IS_EXISTING}
					value={values[IS_EXISTING]}
					onChange={(e) => {
						setFieldValue(
							IS_EXISTING,
							['true', true].includes(e.target.value), // == 'true'
						);

						[
							CLIENT_NAME,
							CLIENT_ID,
							INDUSTRY,
							FIRST_NAME,
							LAST_NAME,
							EMAIL,
							PHONE,
							PHONE2,
							DATE_OF_BIRTH,
							WEBSITE,
							ADDRESS,
							CITY,
							COUNTRY,
							POSTCODE,
							SUBURB,
						].forEach((i) => {
							setFieldValue(i, initialValues[i]);
						});
					}}
					items={[
						{
							value: false,
							label: 'New client',
							disabled: disabled || !canCreate,
						},
						{
							value: true,
							label: 'Existing client',
							disabled: disabled || values[IS_PROSPECT],
						},
					]}
				/>
			</FormControl>
		</Grid>
	);
};
